export const WARRANTY_CARDS_FEATURE_FLAG = false;

export const TEST_FEATURE_FLAG = true;

export const MAINTENANCE_PAGE_FEATURE_FLAG = true;
